var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M1507,35a10,10,0,1,1,7.071-2.929A9.935,9.935,0,0,1,1507,35Zm-5.072-10.2h0l-.928.837,3.653,3.318,7.842-7.122-.921-.836-6.92,6.279-2.725-2.475Z",
    transform: "translate(-1497 -15)",
    fill: "#2db273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBig);
export default __webpack_public_path__ + "static/media/success-big.f4cb13b8fc200cafbb2781ba6eb5d493.svg";
export { ForwardRef as ReactComponent };